<template>
  <div class="sched-app-daily-listing">
    <template v-if="isReady">
      <template v-for="(e, i) in data">
        <daily-entry v-if="e.series_title.toLowerCase().includes(filter)" :key="i" :data="e" :allFull="fullView" :channel="channel"/>
      </template>
    </template>
  </div>
</template>

<script>
import DailyEntry from '@/components/DailyEntry.vue'

export default {
  components: {
    DailyEntry
  },

  computed: {
    data () {
      return this.$store.state.schedData
    },
    channel () {
      return this.$store.state.channel.value
    },
    isReady () {
      return this.$store.state.ready
    },
    filter () {
      return this.$store.state.filter
    },
    fullView () {
      return this.$store.state.fullView
    }
  }
}
</script>

<style scoped>
.sched-app-daily-listing {
    height: calc(100% - 94px);
    background: #EFEFEF;
    padding: 20px;
    overflow-y: auto;
}
</style>
